<template><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <line x1="9.3999" y1="0.799805" x2="9.3999" y2="19.9998" stroke="currentColor" stroke-width="1"/>
  <line x1="19.2002" y1="10.2002" x2="0.000198364" y2="10.2002" stroke="currentColor" stroke-width="1"/>
</svg>
</template>